
  export default {
    mounted() {
      this.zoom = 1
      this.content = this.el.querySelector("[data-zoom-content]")
      this.label = this.el.querySelector("[data-zoom-label]")
      this.kind = this.el.dataset.kind
      this.el.querySelectorAll("[data-zoom]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const action = btn.dataset.zoom
          if (action === "in") this.zoom = Math.min(3, +(this.zoom + 0.25).toFixed(2))
          else this.zoom = Math.max(0.5, +(this.zoom - 0.25).toFixed(2))
          this.apply()
        })
      })
      this.apply()
    },
    apply() {
      if (!this.content) return
      const z = this.zoom
      if (this.kind === "pdf") {
        this.content.style.width = `${100 / z}%`
        this.content.style.height = `${100 / z}vh`
      }
      this.content.style.transform = `scale(${z})`
      if (this.label) this.label.textContent = `${Math.round(z * 100)}%`
    },
  }
